<template>
  <div>
    <SubHeader title="Business Details" />
    <b-form @submit="onSubmit"
            class="container"
            v-if="company && lookups">
      <b-row class="my-1">
        <b-col md="3">
          <label for="companySectors">Major Sector</label>
        </b-col>
        <b-col md="9">
          <multiselect v-model="company.companySectors"
                       tag-placeholder="Add this as new tag"
                       placeholder="Search or add a tag"
                       label="name"
                       track-by="id"
                       :options="lookups.sectors"
                       :multiple="true"
                       :hide-selected="true"
                       :disabled="onTheMarket"></multiselect>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
          <label for="companySubSectors">Sub-Sector</label>
        </b-col>
        <b-col md="9">
          <multiselect v-model="company.companySubSectors"
                       tag-placeholder="Add this as new tag"
                       placeholder="Search or add a tag"
                       label="name"
                       track-by="id"
                       :options="subSectors"
                       :multiple="true"
                       :hide-selected="true"
                       :disabled="onTheMarket"></multiselect>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3">
          <label for="sicCodes">SIC Code(s)</label>
        </b-col>
        <b-col md="9" v-if="company.sicCodesWithDescription">
          <b-form-textarea id="sicCodes"
                           v-model="company.sicCodesWithDescription"
                           rows="8"
                           :disabled="true"></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3">
          <label for="keyword">Keywords</label>
        </b-col>
        <b-col md="9">
          <b-form-textarea id="keyword"
                           v-model="keyword.keyword"
                           rows="8"
                           :disabled="onTheMarket"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
          <label for="businessDescription">Business Description</label>
        </b-col>
        <b-col md="9">
          <b-form-textarea id="businessDescription"
                           v-model="company.businessDescription"
                           :disabled="onTheMarket"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3"> </b-col>
        <b-col md="6">
          <b-button class="my-1 margin-right"
                    variant="success"
                    type="button"
                    @click="save()"
                    :disabled="onTheMarket"><font-awesome-icon icon="save" />&nbsp;Save</b-button>
          <b-button class="my-1"
                    variant="danger"
                    type="button"
                    @click="reset"
                    :disabled="onTheMarket"><font-awesome-icon icon="times" />&nbsp;Cancel Changes</b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="6">
          <Feedback ref="saveFeedback" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import SubHeader from "@/components/shared/SubHeader.vue";
import CompanyService from "@/services/Company.service";
import Feedback from "@/components/shared/Feedback.vue";

export default {
  components: { Multiselect, SubHeader, Feedback },
  props: {
    initialCompany: Object,
    lookups: Object,
  },
  mounted() {
    if (this.initialCompany && this.company == null) {
      this.company = {...this.initialCompany};
      this.onTheMarket = this.initialCompany.companyLocked;

      if (this.company && (!this.company.companyKeyword && this.company.companyKeyword.length == 0)) {
        this.keyword = { keyword: "" };
      } else {
        this.keyword = {...this.initialCompany.companyKeyword[0]}
      }
    }
  },

  data() {
    return {
      company: null,
      keyword: null,
      subSectors: [],
      onTheMarket: false,
    };
  },
  watch: {
    initialCompany: function() {
      this.company = { ...this.initialCompany };
      if (this.company && (!this.company.companyKeyword && this.company.companyKeyword.length == 0)) {
        this.company.companyKeyword = { keyword: "" };
        this.keyword = { keyword: "" };
      } else {
        this.keyword = {...this.initialCompany.companyKeyword[0]}
      }
      this.filterSubSectors();
    },
    lookups : {
      handler: function () {
        if (!this.company) return;
        this.filterSubSectors();
      },
      deep: true
    },
    'company.companySectors': {
      handler: function () {
        if (!this.lookups) return;
        this.filterSubSectors();
      },
      deep: true
    }
  },
  methods: {

    filterSubSectors() {
        if (this.company.companySectors == null) {
          this.company.companySectors = [];
        }

        if (this.company.companySubSectors == null) {
          this.company.companySubSectors = [];
        }

        this.subSectors = this.lookups.subSectors.filter((x) =>
          this.company.companySectors.some((y) => y.id == x.sectorId)
        );

        this.company.companySubSectors = this.company.companySubSectors.filter((x) =>
          this.company.companySectors.some((y) => y.id == x.sectorId)
        );
    },
    async onSubmit(evt) {
      evt.preventDefault();
    },
    reset() {
      this.company = {...this.initialCompany}

      if (this.company && (!this.company.companyKeyword && this.company.companyKeyword.length == 0)) {
        this.keyword = { keyword: "" };
      } else {
        this.keyword = {...this.initialCompany.companyKeyword[0]}
      }
    },
    save() {

      var form = {
        companyId: this.company.id,
        companySectorIds: this.company.companySectors.map(x => x.id),
        companySubSectorIds: this.company.companySubSectors.map(x => x.id),
        businessDescription: this.company.businessDescription,
        keywords: this.keyword.keyword
      }

      CompanyService.saveCompanySectors(form).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
      });
    },
  },
};
</script>

<style scoped>
</style>
